import React, { Component } from 'react';
import { Form, TextArea, Message, Button, Segment } from 'semantic-ui-react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import Header from './Header';
import Papa from 'papaparse';
import { COLUMNS, DEFAULTSORTED, DEFAULTPAGESIZE } from './table.conf.js';
import { updateInPath, nullsToStrings, } from '../../../../common/utils';
import {
  clone,
  map,
  pipe,
  filter,
  complement,
  isEmpty,
  prepend,
  find,
  sortBy,
  prop
} from 'ramda';

class Teams extends Component {
  constructor(props) {
    super();

    this.state = {
      members: [],
      csv: '',
      errors: null,
      eventId: null,
      competitionId: null,
      userId: null,
      name: "",
      robotName: "",
      hasAcceptedCompetitionRules: true,
      mentor: {}
    };
  }

  handleDetailsChange = (name, value) => {
    this.setState(s => updateInPath(s, name, value));
  }

  handleFieldChange = (e, {name, value}) => {
    this.setState(s => updateInPath(s, name, value));
    // often name === robotName
    if (name == 'name' && this.state.robotName === '') {  
      this.setState(s => updateInPath(s, 'robotName', value));
    }
  }

  // TODO show errors
  handleCsvChange = (e, { value : csv }) => {
    var parsed = Papa.parse(csv);
    const f = pipe(
      clone(),
      map(r => {
        return {
          given_name: r[0],
          family_name: r[1],
          email: r[2],
          year_of_birth: parseInt(r[3]),
          occupation: r[4],
          occupation: "Student",
          occupation_details: "",
          country_of_residence: "ee",
          county_of_residence: "Harju"
        };
      })
    )(parsed.data);

    this.setState(s => updateInPath(s, 'csv', csv));
    this.setState(s => updateInPath(s, 'members', f));
    this.setState(s => updateInPath(s, 'errors', parsed.errors.length ? JSON.stringify(parsed.errors) : null));
  };

  handleSave = () => {
    const data = clone(this.state);
    delete data.errors;
    delete data.csv;
    
    this.props.onSave(data, () => {
      console.log('success!');
      this.setState(s => updateInPath(s, 'csv', ''));
      this.setState(s => updateInPath(s, 'members', []));
      this.setState(s => updateInPath(s, 'name', ''));
      this.setState(s => updateInPath(s, 'robotName', ''));
    });
  }

  render() {
    // no props.data, refresh, loading!
    const { events, refresh, loading} = this.props;

    return (
      <div>
        <Header
          events={events}
          disabled={loading}
          onChange={this.handleDetailsChange}/>
        <Segment>
          <Form>
            <TextArea
              placeholder='paste CSV here (without header)'
              value={this.state.csv}
              onChange={this.handleCsvChange}/>
            <br /><br />
            <Form.Group>
              <Form.Input
                width={6}
                label='Team name'
                name='name'
                value={this.state.name}
                onChange={this.handleFieldChange} />
              <Form.Input
                width={6}
                label='Robot name'
                name='robotName'
                value={this.state.robotName}
                onChange={this.handleFieldChange} />
              <Form.Button
                width={4}
                size='tiny'
                disabled={!!this.state.errors || isEmpty(this.state.members)}
                content="Save team"
                onClick={this.handleSave}
              />
            </Form.Group>
          </Form>
        </Segment>
        {
          this.state.errors &&
            <Message negative>
              <Message.Header>CSV parsing failed</Message.Header>
              <p>{this.state.errors}</p>
            </Message>
        }
        <ReactTable
          ref={ (r) => { this.reactTable = r; } } 
          className='-striped -highlight'
          data={this.state.members}
          loading={loading}
          columns={COLUMNS}
          defaultSorted={DEFAULTSORTED}
          defaultPageSize={DEFAULTPAGESIZE}
        />
      </div>
    );
  };
};

export default Teams;



// WEBPACK FOOTER //
// ./src/private/admin/components/CsvImport/index.js